import { render, staticRenderFns } from "./TableCellPositionTitle.vue?vue&type=template&id=3cc2985c"
import script from "./TableCellPositionTitle.vue?vue&type=script&lang=js"
export * from "./TableCellPositionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports